(function () {
  function initSection(section) {
    if (!section || section.dataset.frpInitialized === 'true') return;
    section.dataset.frpInitialized = 'true';
    section.classList.add('frp-js');

    const revealItems = section.querySelectorAll('.frp-reveal');
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('frp-on');
          revealObserver.unobserve(entry.target);
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -50px 0px'
      });

      revealItems.forEach((item, index) => {
        if (!item.style.getPropertyValue('--frp-delay')) {
          item.style.setProperty('--frp-delay', `${index * 70}ms`);
        }
        revealObserver.observe(item);
      });

      const rows = section.querySelectorAll('[data-frp-row]');
      const rowObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const row = entry.target;
          const content = row.querySelector('[data-frp-content]');
          const visual = row.querySelector('[data-frp-visual]');

          row.classList.add('is-active');
          window.setTimeout(() => {
            if (content) content.classList.add('is-visible');
          }, 100);
          window.setTimeout(() => {
            if (visual) visual.classList.add('is-visible');
          }, 260);

          rowObserver.unobserve(row);
        });
      }, {
        threshold: 0.28
      });

      rows.forEach((row) => rowObserver.observe(row));
    } else {
      revealItems.forEach((item) => item.classList.add('frp-on'));
      section.querySelectorAll('[data-frp-row]').forEach((row) => {
        row.classList.add('is-active');
        row.querySelector('[data-frp-content]')?.classList.add('is-visible');
        row.querySelector('[data-frp-visual]')?.classList.add('is-visible');
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-recipes-process]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }
})();
